import $ from 'cash-dom'
import { debounce, throttle } from '../utilities/toolkit'

const headers = $('.mobile-header, .desktop-header')

const checkHeaderPosition = () => {
  if (window.pageYOffset > 60) {
    headers.attr('data-scrolling', 'true')
    $('[data-action="device-sticky-cart"]').addClass('hidden')
  } else if (window.pageYOffset < 50) {
    headers.attr('data-scrolling', 'false')
    $('[data-action="device-sticky-cart"]').removeClass('hidden')
  }
}

const stickyAddToCart = () => {
  if ($(window).width() < 767) {
    $('[data-action="sticky-button"]').text('Buy')
  } else {
    $('[data-action="sticky-button"]').text('Add to cart')
  }
}

window.addEventListener('scroll', throttle(checkHeaderPosition, 50), {
  passive: true,
})

window.addEventListener('scroll', debounce(checkHeaderPosition, 150), {
  passive: true,
})

$(document).ready(() => {
  checkHeaderPosition()
  stickyAddToCart()
})

$(window).on('resize', () => {
  stickyAddToCart()
})
